const url_prifix = "/api/verification-management";
export const PAN_VERIFY = `${url_prifix}/pan-verify`;
export const IFSC_VERIFY = `${url_prifix}/ifsc-verify`;
export const UPI_VERIFY = `${url_prifix}/upi-verify`;
export const GSTIN_VERIFY = `${url_prifix}/gstin-verify`;
export const BANK_AC_VERIFY = `${url_prifix}/bankaccount-verify`;
